function Footer() {
  return <footer>Copyright &copy; {new Date().getFullYear()} Valentina</footer>;
}

export default Footer;
